import { RefObject, useEffect } from 'react'
import debounce from 'lodash/debounce'

export const useCloseToBottom = (ref: RefObject<HTMLDivElement>, callback: any) => {
  const offset = 400

  const handleScroll = debounce(() => {
    const rect = ref.current?.getBoundingClientRect()

    if(!rect) return

    const offsetBottom = rect.bottom - window.innerHeight;

    if(offsetBottom < offset) {
      callback()
    }
  }, 100)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  return { isCloseToBottom: false }
}